import React from "react";
import { BannerContextInterface, BannerDetails } from "@pepdirect/ui/banner";

export const BannerContext = React.createContext<BannerContextInterface>({
  setBannerDetails: (_details: BannerDetails | null) => {},
  bannerDetails: null,
  setBannerAutoDismiss: (_dismissBanner: boolean) => {},
  bannerAutoDismiss: false,
});
